import { App } from 'vue'
import store from '@/store'
import type { IRootWithModule } from '@/store/types'

/**
 * 权限指令
 * @description 用于根据用户权限控制元素的显示/隐藏
 * @example <el-button v-permission="'sys:user:add'">新增</el-button>
 * @example <el-button v-permission="['sys:user:add', 'sys:user:edit']">新增/编辑</el-button>
 */
export function setupPermissionDirective(app: App) {
  app.directive('permission', {
    mounted(el: HTMLElement, binding: any) {
      const permissionKey = binding.value

      if (!permissionKey) {
        // 没有设置权限key，不做处理
        return
      }

      let hasPerm = false
      const permissions = (store.state as unknown as IRootWithModule).login.permissions || []

      if (typeof permissionKey === 'string') {
        // 单个权限
        hasPerm = permissions.includes(permissionKey)
      } else if (Array.isArray(permissionKey)) {
        // 多个权限，只要有一个就显示
        hasPerm = permissionKey.some((key) => permissions.includes(key))
      }

      if (!hasPerm) {
        // 没有权限，隐藏元素
        el.style.display = 'none'
      }
    },
    updated(el: HTMLElement, binding: any) {
      // 组件更新时重新检查权限
      const permissionKey = binding.value

      if (!permissionKey) {
        return
      }

      let hasPerm = false
      const permissions = (store.state as unknown as IRootWithModule).login.permissions || []

      if (typeof permissionKey === 'string') {
        hasPerm = permissions.includes(permissionKey)
      } else if (Array.isArray(permissionKey)) {
        hasPerm = permissionKey.some((key) => permissions.includes(key))
      }

      if (!hasPerm) {
        el.style.display = 'none'
      } else {
        el.style.display = ''
      }
    }
  })
}
